import type { CompanyRiskReport } from '@nestjs-boilerplate/types';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api-client';

export type { CompanyRiskReport, CompanyRiskRow } from '@nestjs-boilerplate/types';

export const companyRiskQueryKeys = {
  all: ['admin', 'company-risk'] as const,
};

/**
 * Fetches every firm's risk position, riskiest first.
 *
 * Not paginated: the row count is the number of companies on the platform,
 * which is bounded by customers rather than by activity.
 */
export async function getCompanyRisk(): Promise<CompanyRiskReport> {
  return apiClient.fetch<CompanyRiskReport>('/admin/companies/risk');
}

export function useCompanyRisk() {
  return useQuery({
    queryKey: companyRiskQueryKeys.all,
    queryFn: getCompanyRisk,
  });
}
